const requireTerms = process.env.REACT_APP_REQUIRE_TERMS === "true";

export default { requireTerms };
